import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { get } from '../../../api/fetch';
import { AuthLevel } from '../types/Auth';

const loggedInKey = 'user-logged-in';

export const useIsLoggedIn = (): UseQueryResult<boolean> => {
  return useQuery({
    queryKey: [loggedInKey],
    queryFn: async () => {
      const authLevel = await get<AuthLevel>('/api-tools/v1/open/auth-level');
      if (authLevel?.value > 0) return true;
      return false;
    }
  });
};
